import { render, staticRenderFns } from "./attLeaveEdit.vue?vue&type=template&id=2855d8cc&scoped=true"
import script from "./attLeaveEdit.vue?vue&type=script&lang=js"
export * from "./attLeaveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2855d8cc",
  null
  
)

export default component.exports